import axios from '@/http'

// 备课页面获取基本数据
export function gainClassCourseInfoApi(data) {
    return axios({
        url: '/api/prepare-course/index',
        method: 'GET',
        params: data
    })
}

// 获取老师的学科列表
export function getTeacherSubjects(data) {
    return axios({
        url: '/api/teacher-subject/get-teacher-subjects',
        method: 'GET',
        params: data
    })
}

// 获取年级列表
export function getSecondSubjects(data) {
    return axios({
        url: '/api/teacher-subject/get-second-subjects',
        method: 'GET',
        params: data
    })
}

// 获取章列表
export function getThirdSubjects(data) {
    return axios({
        url: '/api/teacher-subject/get-third-subjects',
        method: 'GET',
        params: data
    })
}

// 获取平台课程列表
export function getAkdmCourses(data) {
    return axios({
        // url: '/api/teacher-subject/get-akdm-courses', // 无自定义课
        url: '/api/teacher-subject/get-classes-courses', // 有自定义课  //旧 有坑
        method: 'GET',
        params: data
    })
}


// 获取课程列表
export function getAkdmOrClassesCourse(data) {
    return axios({
        url: '/api/teacher-subject/get-akdm-or-classes-courses', // 有自定义课 // 2020/4/1 新
        method: 'GET',
        params: data
    })
}

// // 获取课程
// export function getCourse(data) {
//     return axios({
//         // url:'/api/teacher-subject/get-classes-courses',
//         url: '/api/teacher-subject/get-akdm-courses',
//         method: 'GET',
//         params: data
//     })
// }


// 获取我的资源包列表
export function getMixResources(data) {
    return axios({
        url: '/api/teacher-course/get-mix-resources',
        method: 'GET',
        params: data
    })
}

// 我的资源包-资源排序
export function sortMixResource(data) {
    return axios({
        url: '/api/teacher-course/sort-mix-resource',
        method: 'GET',
        params: data
    })
}

// 我的资源包添加资源
export function addMixResource(data) {
    return axios({
        url: '/api/teacher-course/add-mix-resources',
        method: 'POSt',
        data
    })
}

// 我的资源包 资源拖拽排序
export function dragDropMixResources(data) {
    return axios({
        url: '/api/teacher-course/drag-drop-mix-resources',
        method: 'POSt',
        data
    })
}

// 我的资源包删除资源
export function delMixResource(data) {
    return axios({
        url: '/api/teacher-course/del-mix-resources',
        method: 'post',
        data
    })
}

// 删除分享方案
export function delShare(data) {
    return axios({
        url: '/api/class-course-share/del-share',
        method: 'GET',
        params: data
    })
}

// 检测是否同意协议
export function isNeedAgreeSchoolProtocol(data) {
    return axios({
        url: '/api/prepare-course/is-need-agree-school-protocol',
        method: 'POSt',
        data
    })
}

// 试卷-添加课程空试卷
export function addCourseEmptyExam(data) {
    return axios({
        url: '/api/teacher-course/add-course-empty-exam',
        method: 'GET',
        params: data
    })
}

// 试卷-添加并推送问题探究
export function addAndPushProblemExplore(data) {
    return axios({
        url: '/api/problem-explore/add-and-push-problem-explore',
        method: 'POSt',
        data
    })
}

// 试卷-编辑试卷
export function editCourseExam(data) {
    return axios({
        url: '/api/teacher-course/edit-course-exam',
        method: 'POSt',
        data
    })
}

// 试卷-编辑问题探究
export function addProblemExplore(data) {
    return axios({
        url: '/api/problem-explore/add-problem-explore',
        method: 'POSt',
        data
    })
}

// 试卷-修改试卷名称
export function updateExamTitle(data) {
    return axios({
        url: '/api/teacher-course/update-exam-title',
        method: 'GET',
        params: data
    })
}


// 试卷-获取我的答题卡分页列表
export function getTeacherExamCardPages(data) {
    return axios({
        url: '/api/exam-card-teacher/get-teacher-exam-card-pages',
        method: 'GET',
        params: data
    })
}

// // 获取爱米预置课程包
// export function getAkdmCoursePackage(data) {
//     return axios({
//         url: '/api/prepare-course/get-akdm-course-package',
//         method: 'GET',
//         params: data
//     })
// }

// 资源库-我的收藏分页
export function getResourceCollectPage(data) {
    return axios({
        url: '/api/prepare-course/get-resource-collect-page',
        method: 'POSt',
        data
    })
}

// 习题库-共享习题库分页
export function getSchoolQuestionPages(data) {
    return axios({
        url: '/api/question-page/get-school-question-pages',
        method: 'POSt',
        data
    })
}

// 习题库-爱米习题库分页
export function getSubjectTagQuestionPage(data) {
    return axios({
        url: '/api/question-page/get-subject-tag-question-pages',
        method: 'POSt',
        data
    })
}

// 习题库-我的习题库分页
export function getTeacherQuestionPages(data) {
    return axios({
        url: '/api/question-page/get-teacher-question-pages',
        method: 'POSt',
        data
    })
}

// 习题库-全部习题分页
export function getAllQuestionPages(data) {
    return axios({
        url: '/api/question-page/get-all-question-pages',
        method: 'POSt',
        data
    })
}

// 试卷库-共享试卷库分页
export function getSchoolExamPages(data) {
    return axios({
        url: '/api/prepare-course/get-school-exam-pages',
        method: 'GET',
        params: data
    })
}

// 试卷库-爱米试卷库分页
export function getAkdmExamPages(data) {
    return axios({
        url: '/api/prepare-course/get-akdm-exam-pages',
        method: 'GET',
        params: data
    })
}

// 试卷库-我的试卷库分页
export function getTeacherExamPages(data) {
    return axios({
        url: '/api/prepare-course/get-teacher-exam-pages',
        method: 'GET',
        params: data
    })
}

// 试卷库-全部试卷分页
export function getAllExamPages(data) {
    return axios({
        url: '/api/prepare-course/get-all-exam-pages',
        method: 'GET',
        params: data
    })
}


// 资源库-共享资源库分页
export function getSchoolResourcePages(data) {
    return axios({
        url: '/api/prepare-course/get-school-resource-pages',
        method: 'POSt',
        data
    })
}

// 资源库-爱米资源库分页
export function getPlatformResourcePages(data) {
    return axios({
        // url: '/api/prepare-course/get-platform-resource-pages', // 爱米平台资源接口
        url: '/api/prepare-course/get-im-share-resource-pages',  // 合并爱米和共享资源接口
        method: 'POSt',
        data
    })
}

// 资源库-我的资源库分页
export function getTeacherResourcePages(data) {
    return axios({
        url: '/api/prepare-course/get-teacher-resource-pages',
        method: 'POSt',
        data
    })
}

// 资源库-全部资源库分页
export function getAllResourcePages(data) {
    return axios({
        url: '/api/prepare-course/get-all-resource-pages',
        method: 'POSt',
        data
    })
}

// 我的资源-更新资源名称
export function updateResourceTitle(data) {
    return axios({
        url: '/api/resource/update-resource-title',
        method: 'GET',
        params: data
    })
}

// 获取固定标签
export function getTagGroup(data) {
    return axios({
        url: '/api/tag/get-tag-group',
        method: 'GET',
        params: data
    })
}

// 获取自定义标签
export function getTagTemplateList(data) {
    return axios({
        url: '/api/tag/get-tag-template-list',
        method: 'GET',
        params: data
    })
}

// 获取自定义子标签
export function getSubTagTemplateList(data) {
    return axios({
        url: '/api/tag/get-sub-tag-template-list',
        method: 'GET',
        params: data
    })
}
// 是否要显示标签
export function checkTagIsShow(data) {
    return axios({
        url: 'api/tag/is-show-tag-group',
        method: 'GET',
        params: data
    })
}

// 获取分享列表
export function getShareList(data) {
    return axios({
        url: '/api/class-course-share/get-share-list',
        method: 'GET',
        params: data
    })
}

// 获取分享包资源列表
export function getShareResources(data) {
    return axios({
        url: '/api/class-course-share/get-share-resources',
        method: 'GET',
        params: data
    })
}

// 设置分享已读
export function updateIsRead(data) {
    return axios({
        url: '/api/class-course-share/update-is-read',
        method: 'GET',
        params: data
    })
}
/**********限时训练***********/
// 试卷库-共享试卷库分页
export function addLimitExam(data) {
    return axios({
        url: '/api/teacher-course/add-course-empty-exam',
        method: 'GET',
        params: data
    })
}
